<div class="dd-holder">
    <ul
        class="dropdown-menu"
        [class]="hide() ? 'close' : 'open'"
        #dropdownList>
        @for (item of items; track item; let itemIndex = $index) {
            <li (click)="selectItem(item)">
                <a
                    (mouseenter)="highlightItem(itemIndex)"
                    (mouseleave)="clearHighlight()"
                    [ngClass]="{'highlighted': itemIndex===highlightedIndex}"
                    [innerHTML]="formatOutput(item)"></a>
            </li>
        }
    </ul>
</div>
